export const DELIVERY_SCHEDULE = {
  ROOT: '/deliverySchedule',
  APARTMENTS: '/deliverySchedule/apartments',
  APARTMENTS_DETAIL: '/deliverySchedule/apartments/detail',
  APARTMENTS_DETAIL_ID: '/deliverySchedule/apartments/detail/:id',
};
